import { createContext, useContext, useReducer } from "react";

const csoSignUpContextInitialState = {
  entityNumber: 213321,
  entityForm: "1",
  name: "",
  nameKana: "",
  representativeName: "",
  incorporationDate: "",
  prefecture: "北海道",
  city: "",
  phoneNumber: "",
  industry: "農業",
  mission: "",
  sustainabilityPolicy: "",
  collaborationExperienceTime: "",
  collaborationNeeds: [],
  focusedSdges: [],
  focusedStakeholders: [],
  interestingActivity: [],
  interestingCountry: [],
  revenue_category: "UmV2ZW51ZUNhdGVnb3J5Tm9kZTow",
};

const CsoSignUpContext = createContext({});

const CsoSignUpContextReducer = (state, action) => {
  switch (action.type) {
    case "HANDLE_RADIO_CHANGE":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case "HANDLE_CHECKBOX_CHANGE":
      return {
        ...state,
        [action.payload.name]: action.payload.checked
          ? [...state[action.payload.name], action.payload.value]
          : state[action.payload.name].filter(
              (item) => item !== action.payload.value
            ),
      };
    case "HANDLE_BULK_CHANGE":
      return {
        ...state,
        ...action.payload,
      };
    case "HANDLE_CHANGE":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    default:
      return {
        ...state,
        [action.type]: action.payload,
      };
  }
};

const CsoSignUpContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    CsoSignUpContextReducer,
    csoSignUpContextInitialState
  );

  return (
    <CsoSignUpContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </CsoSignUpContext.Provider>
  );
};

export const useCsoSignUpContext = () => {
  const context = useContext(CsoSignUpContext);
  return context;
};

export default CsoSignUpContextProvider;
